import {
    clearConversationsAction, 
    receiveConversationsAction, 
    requestConversationsAction,
    requestMessagesAction,
    receiveMessagesAction,
    clearMessagesAction,
    requestFailed,
    requestStarted,
    requestSucceeded
} from "./actions";
import User from "../_data/models/User";
import ConversationRepository from "../_repositories/conversationRepository";
import Conversation from "../_data/models/Conversation";
import {ResourceType} from "../_helpers/data";
import {addDataAction} from "../_data/actions";
import * as _ from 'lodash';
import {dataByResourceNameSelector} from "../_data/selectors";
import {fetchUser,} from "../user/middlewares";
import {messagesSelector} from "./selectors";
import {conversationByIdSelector} from "../_data/selectors";

export function initializeConversation(conversationId) {
    return (dispatch, getState) => {
        dispatch(clearMessagesAction());
        dispatch(fetchMessagesBy(conversationId));
    }
}

export function initializeNewConversation(recipientId) {
    return (dispatch, getState) => {
        dispatch(clearMessagesAction());
        dispatch(fetchUser(recipientId));
        dispatch(fetchMessagesByRecipient(recipientId));
    }
}

export function fetchConversations(page: number = 1) {
    return (dispatch, getState) => {
        dispatch(requestConversationsAction());
        ConversationRepository.get(page).then(data => {
            const {conversations, meta} = data;
            const _conversations = _.chain(conversations).map(c => {
                return {...c, userId1: c.user1.id, userId2: c.user2.id, lastMessageId: c.last_message.id}
            }).value();

            dispatch(addDataAction({
                resource: ResourceType.conversation,
                data: _conversations
            }));

            dispatch(receiveConversationsAction({
                meta: meta,
                conversationIds: conversations.map(c => c.id)
            }));
        });
    }
}

export function fetchMessagesByRecipient(recipientId, page: number = 1, perPage: number = 5) {
    return (dispatch, getState) => {   
        
        dispatch(requestStarted());
        ConversationRepository.getMessagesByRecipientId(recipientId, page, perPage).then(data => {
            const {messages, meta} = data;
            console.log(messages);
            console.log('hi');
            const _messages = _.chain(messages.reverse()).map(m => {
                return {...m, senderId: m.sender.id}
            }).value();

            dispatch(addDataAction({
                resource: ResourceType.message,
                data: _messages
            }));

            dispatch(receiveMessagesAction({
                meta: meta,
                messageIds: messages.map(m => m.id)
            }));

            return dispatch(requestSucceeded());
        });      
   
    }
}

export function fetchMessagesBy(conversationId, page: number = 1, perPage: number = 10) {
    return (dispatch, getState) => {   

        // const conversations = dataByResourceNameSelector(getState(), ResourceType.conversation);
        // if(conversations.toArray().length == 0) {
        //     dispatch(fetchConversations());
        // }

        dispatch(requestStarted());
        ConversationRepository.getMessages(conversationId, page, perPage).then(data => {
            const {messages, meta} = data;

            const _messages = _.chain(messages).map(m => {
                return {...m, senderId: m.sender.id}
            }).value();

            dispatch(addDataAction({
                resource: ResourceType.message,
                data: _messages
            }));

            dispatch(receiveMessagesAction({
                meta: meta,
                messageIds: messages.map(m => m.id)
            }));

            return dispatch(requestSucceeded());
        });      
   
    }
}

export function sendMessage(userId:number, conversationId:number,  content: string, isNew: boolean = false) {
    return (dispatch, getState) => {       
        dispatch(requestStarted());           
        ConversationRepository.sendMessage(userId ,conversationId, content, isNew).then(data => {
            const {message, meta} = data;

            // dispatch(initializeConversation(conversationId));
           const {ids} = messagesSelector(getState());    
           console.log(ids);

            const _message = {...message, senderId:message.sender.id};

            dispatch(addDataAction({
                resource: ResourceType.message,
                data: [_message]
            }));

            dispatch(receiveMessagesAction({
                messageIds: [message.id]
            }));

            dispatch(requestSucceeded());
        });        
    }
}

export function readMessage(conversationId) {
    return (dispatch, getState) => {         
        ConversationRepository.readMessage(conversationId).then(data => {      
                if (data.error) {
                    return dispatch(requestFailed({requestErrors: ["Failed to read the message"]}));
                }    
        });       

        const conversation = conversationByIdSelector(getState(), conversationId);
        const _conversation = {...conversation, unreadCount:0};

        dispatch(addDataAction({
            resource: ResourceType.conversation,
            data: [_conversation]
        }));
    }
}


// WEBPACK FOOTER //
// ./app/client/message/middlewares.ts